package com.neurobs.ccabserver.transcriptreview.components.transcriptreview

import com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components.{EngineTranscript, ReviewableTranscript, WordAddition}
import com.neurobs.ccabserver.transcriptreview.states.{AudioContextContext, RecordingTranscriptReviewStateGenerator, TestTranscriptReviewStateGenerator, WordAdditionStateProvider}
import com.neurobs.js.view.{AudioViewer, ReactAudioViewer}
import com.neurobs.react.StyleUtil
import com.neurobs.util.TimeSeconds
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html._

@react
object RecordingTranscriptView {
	case class Props(viewer: AudioViewer)

	val component = FunctionalComponent[Props] { props =>
		val recordingState = RecordingTranscriptReviewStateGenerator.accessState
		val testState = TestTranscriptReviewStateGenerator.accessState
		val audioContext = AudioContextContext.accessState()

		val viewer = props.viewer
		val options = AudioViewer.Options(
			cursorColor = "white",
			waveColor = "yellow",
			pixelHeight = 128,
			normalize = true,
			pixelsPerSecond = testState.PPS,
			spectogram = None
		)
		val audioDuration: TimeSeconds = TimeSeconds(viewer.audio.duration)

		div(
			div(
				className := "recording-container",
			)(
				ReactAudioViewer(viewer, options, audioContext),
				ReviewableTranscript(audioDuration),
				WordAdditionStateProvider(
					WordAddition(audioDuration)
				),
				testState.handler.value.labelList.transcripts(recordingState.handler) map {
					case Some(t) => EngineTranscript(audioDuration, t): ReactElement
					case None => div(style := StyleUtil.makeStyle(("height", "20px")))()
				}

//				EngineTranscript(audioDuration, recordingState.casrTranscript),
//				recordingState.reviewedTranscripts.map(transcript => {
//					EngineTranscript(audioDuration, transcript).withKey(transcript.engineIdentifier)
//				}),
//				recordingState.asrTranscripts.map(transcript => {
//					EngineTranscript(audioDuration, transcript).withKey(transcript.engineIdentifier)
//				}),
			)
			//,
			//TranscriptTable()
		)
	}
}
